import type { SupportFilterSchema } from './filter-schema';

export const filterDefaultValues: Readonly<SupportFilterSchema> = {
  search: '',
  status: [],
  priority: [],
  agent: [],
  contact: [],
} as const;

export const supportPagePreDefinedFilters: Readonly<SupportFilterSchema> = {
  search: '',
  status: [
    {
      value: '2',
      label: 'Open',
    },
    {
      value: '3',
      label: 'Pending',
    },
    {
      value: '6',
      label: 'Waiting on Customer',
    },
    {
      value: '7',
      label: 'Waiting on Third Party',
    },
    {
      value: '8',
      label: 'Waiting on Developer',
    },
  ],
  priority: [],
  agent: [],
  contact: [],
} as const;
